(() => {
  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-ss-mobile-sort]');
    if (!button) return;
    const drawer = document.getElementById('filters-drawer');
    if (!drawer) return;
    event.preventDefault();
    if (!customElements.get('theme-drawer')) await customElements.whenDefined('theme-drawer');
    drawer.open();
    requestAnimationFrame(() => {
      const select = drawer.querySelector('select[name="sort_by"]:not(:disabled)');
      const target = select || drawer.querySelector('summary');
      target?.focus({ preventScroll: true });
      target?.scrollIntoView({ block: 'nearest' });
    });
  });
})();



/* Wait until the drawer releases scroll locking before moving to the stores. */
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('.ss-drawer-nav a[href*="#our-stores"]');
  if (!link) return;
  const drawer = link.closest('header-drawer');
  if (!drawer) return;
  event.preventDefault();
  const destination = new URL(link.href, location.origin);
  const navigate = () => {
    if (destination.pathname === location.pathname) {
      history.pushState(null, '', destination.href);
      document.getElementById('our-stores')?.scrollIntoView({ block: 'start', behavior: 'auto' });
    } else {
      location.assign(destination.href);
    }
  };
  if (drawer.isOpen) {
    drawer.addEventListener('suit-shop:drawer-closed', navigate, { once: true });
    drawer.close();
  } else {
    navigate();
  }
});
